import React from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedNumber } from 'react-intl';
import { orderBy as _orderBy } from 'lodash';

import { getColorForString } from 'helpers/charts';

class VklBusinessEquipments extends React.Component {
  getCodeTypeColor = codeType => {
    switch (codeType) {
      case '0':
        return '#80CBC4'; // getColorForString('Einzelausttatungen'); // Einzelausttatungen

      case '1':
        return '#81D4FA'; // getColorForString('Wagenfarbe'); // Wagenfarbe

      case '2':
        return '#9FA8DA'; // getColorForString('Polsterung'); // Polsterung

      case '3':
        return '#CE93D8'; // getColorForString('Pakete'); // Pakete

      case '4':
        return '#ef9a9a'; // getColorForString('Ausstattungslinie'); // Ausstattungslinie

      case '5':
        return '#455A64'; // getColorForString('Minderpreis'); // Minderpreis
    }

    return '#' + getColorForString(codeType);
  };

  render() {
    const {
      intl: { messages },
      projectConfig,
      equipments,
    } = this.props;

    const orderedEquipments = _orderBy(equipments, ['code_type', 'code'], ['desc', 'asc']);

    return (
      <div>
        <h4>{messages.sad.optional_equipment}</h4>
        <Table responsive hover condensed>
          <thead>
            <tr>
              <th style={{ width: '75px', borderLeft: '10px solid transparent' }}>Code</th>
              <th>{messages.name}</th>
              <th class="text-right">{messages.price}</th>
            </tr>
          </thead>
          <tbody>
            {orderedEquipments.map((equipment, i) => {
              // const parentEquipment = _.find(orderedEquipments, { id: equipment.package_id });
              // const parentCode = _.get(parentEquipment, 'code');

              return (
                <tr key={i}>
                  <td style={{ borderLeft: '5px solid ' + this.getCodeTypeColor(equipment.code_type) }}>
                    {equipment.code}
                  </td>
                  <td>{equipment.name}</td>
                  <td class="text-right">
                    <FormattedNumber value={equipment.price} style="currency" currency={projectConfig.data.currency} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Table responsive condensed class="m-b-20">
          <tbody>
            <tr>
              <td
                style={{
                  borderLeft: '5px solid ' + this.getCodeTypeColor('4'),
                  borderBottom: 0,
                  background: 'transparent',
                }}
              >
                {messages.sad.equipment_line}
              </td>
              <td
                style={{
                  borderLeft: '5px solid ' + this.getCodeTypeColor('3'),
                  borderBottom: 0,
                  background: 'transparent',
                }}
              >
                {messages.sad.packages}
              </td>
              <td
                style={{
                  borderLeft: '5px solid ' + this.getCodeTypeColor('2'),
                  borderBottom: 0,
                  background: 'transparent',
                }}
              >
                {messages.sad.upholstery}
              </td>
              <td
                style={{
                  borderLeft: '5px solid ' + this.getCodeTypeColor('1'),
                  borderBottom: 0,
                  background: 'transparent',
                }}
              >
                {messages.sad.car_color}
              </td>
              <td
                style={{
                  borderLeft: '5px solid ' + this.getCodeTypeColor('0'),
                  borderBottom: 0,
                  background: 'transparent',
                }}
              >
                {messages.sad.single_equipments}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
  };
};

export default injectIntl(connect(mapStateToProps)(VklBusinessEquipments));
